import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import SlideFadeTransition from "./SlideFadeTransition.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'DynamicAdviceViewer',
  props: {
    message: { type: String, default: "", required: true },
    messagePrefix: { type: String, default: "" },
    alertContext: { type: String, default: "warning" }
},
  setup(__props) {

const props = __props;

const showMessage = computed<boolean>(() => props.message.length > 0);

const showPrefix = computed<boolean>(() => props.messagePrefix.length > 0);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SlideFadeTransition, null, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(["alert my-2", `alert-${__props.alertContext}`]),
        role: "alert"
      }, [
        _cache[0] || (_cache[0] = _createElementVNode("i", { class: "bi bi-exclamation-circle-fill me-2" }, null, -1)),
        _withDirectives(_createElementVNode("span", null, _toDisplayString(__props.messagePrefix), 513), [
          [_vShow, showPrefix.value]
        ]),
        _createTextVNode(" " + _toDisplayString(__props.message), 1)
      ], 2), [
        [_vShow, showMessage.value]
      ])
    ]),
    _: 1
  }))
}
}

})